import {
    RaikoDatePicker,
    RaikoSectionContainer, RaikoSimpleInputOutlined,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";

import {EtekafService} from "../../serverService/etekafService/EtekafService";
import RaikoBaseDialogContentContainer
    from "../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";

export default function EtekafManagerAddNewList({handleCloseDialog, handleAddNewPlace}) {

    const [startDate, setStartDate] = useState(0);
    const [endDate, setEndDate] = useState(0);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false)

    const service = new EtekafService()

    function handleCreateNewEtekafToList(){
        setLoading(true)
        service.addNewEtekaf(title,startDate,endDate)
            .then(response => {
                handleCloseDialog()
                handleAddNewPlace(response)
                showSuccessMessage("اعتکاف جدید با موفقیت اضافه شد")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }

    
    return (
        <>

            <RaikoBaseDialogContentContainer
            >
                <RaikoSectionContainer
                    title={"افزودن اعتکاف جدید"}
                    actionButtonTitle={"افزودن"}
                    hasActionButton
                    actionButtonOnclickWithValidation={handleCreateNewEtekafToList}
                    actionButtonLoadingState={loading}
                    hasSecondaryButton
                    secondaryButtonTitle={"بازگشت"}
                    secondaryButtonOnClick={handleCloseDialog}
                >
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان"}
                        value={title}
                        setValue={setTitle}
                        required
                    />
                    <RaikoDatePicker
                        label={"تاریخ شروع"}
                        date={startDate}
                        setDate={setStartDate}
                        required={true}
                    />
                    <RaikoDatePicker
                        label={"تاریخ پایان"}
                        date={endDate}
                        setDate={setEndDate}
                        required={true}
                    />
                </RaikoSectionContainer>
            </RaikoBaseDialogContentContainer>
        </>
    )
}